import { useMutation } from '@apollo/client';
import axios from 'axios';
import env from 'src/env';
import { currentLanguage } from 'src/graphql';
import UPDATE_KEYCLOAK_USER_PREFERRED_LANGUAGE from 'src/graphql/mutations/updatePreferredLanguage';
import { selectValidLocale } from 'src/lang/locales';

// API call for language change in Auth0 user metadata
const updateAuth0Metadata = async (locale: string) => {
    const authToken = localStorage.getItem('id_token');
    await axios.request({
        baseURL: env.ssoV1Url,
        url: '/api/profile/metadata',
        method: 'POST',
        headers: { Authorization: `Bearer ${authToken}` },
        data: { locale },
    });
};

const useLanguageChange = () => {
    // API call for language change in Keycloak user metadata
    const [updatePreferredLanguage] = useMutation(UPDATE_KEYCLOAK_USER_PREFERRED_LANGUAGE);

    const changeLanguage = async (locale: string) => {
        const validLocale = selectValidLocale(locale);

        if (validLocale) {
            const htmlEl = document.querySelector('html');

            if (htmlEl) {
                [htmlEl.lang] = validLocale.split('-');
            }

            const ssoVersion = localStorage.getItem('ssoVersion');

            if (ssoVersion === '2') {
                updatePreferredLanguage({ variables: { preferredLanguage: validLocale } });
            } else {
                updateAuth0Metadata(validLocale);
            }
        }

        currentLanguage(validLocale);
    };

    return changeLanguage;
};

export default useLanguageChange;